import React, { useEffect, useState } from 'react';
import { faEllipsisVertical } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Checkbox } from '@mui/material';

const CardSimpleComponent = (props: any) => {
    const [classModoDark, setClassModoDark] = useState(' bg-dark text-white'); 
    const [cardVisible, setCardVisible] = useState(true); 
    const [estiloCardSelecionado, setEstiloCardSelecionado] = useState('0');
    const [loading, setLoading] = useState(false);
        
    const [preferences, setPreferences] = useState<any | null>(() => {
        const storedPreferences = localStorage.getItem("preferences");
        return storedPreferences ? JSON.parse(storedPreferences) : [];
    });

    useEffect(() => {
        if(preferences.darkMode){
            setClassModoDark(' bg-dark text-white');
        } else {
            setClassModoDark(' bg-light');
        }
    }, []);

    useEffect(() => {
        if(props.cardAtual === props.cardSelecionado){
            setEstiloCardSelecionado(' border border-3 border-danger rounded');
        } else {
            setEstiloCardSelecionado('');
        }
    }, [props.cardSelecionado]);

    useEffect(() => {
        setCardVisible(props.visibleCheckbox);
    }, []);

    function changeVisibleCheckbox(value:any) {
        setCardVisible(value);
        props.changeVisibleCheckbox(props.cardAtual, cardVisible);
    }
    
    return (
        <div
            key={`card-base-${props.cardAtual}`}
            onClick={props.onClick}
            className={`card-group width-painel-logistico m-1${(props.visible ? '' : ' d-none')}`}>
                <div className={`card bg-gradient${classModoDark}`}>
                    {!props.enableDrag ? '' : 
                        <Checkbox className='checkbox-card-visible' style={{position: 'absolute', right: 0, bottom: 0}} 
                            checked={cardVisible}
                            onChange={() => changeVisibleCheckbox((prev:any) => !prev)}
                        />
                    }

                    {!props.enableDrag ? '' : <FontAwesomeIcon icon={faEllipsisVertical} title="Arrastar" style={{opacity: 0.3, position: 'absolute', right: 0, top: 0, margin: '3px'}}  />}

                    <div className={`p-1 card-body${estiloCardSelecionado}`} style={{textAlign:"left", display:'inline-grid'}}>
                        <p className="card-text m-1" style={{fontSize:15}}>{props.title}</p>
                        <h5 className={`card-quantity card-title m-1${!props.enableDrag ? '' : ' card-quantity-small'}`} style={{fontSize:40, alignSelf:'end'}}>{props.quantity}</h5>
                    </div>
                </div>
        </div>
    );
}

export default CardSimpleComponent